import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { jsx as _jsx } from "react/jsx-runtime";
function StatsCell({
  crmObject,
  propertyName
}) {
  const value = Number(getPropertyValue(crmObject, propertyName) || '0');
  return /*#__PURE__*/_jsx(FormattedNumber, {
    value: value
  });
}
export default StatsCell;